import { render, staticRenderFns } from "./YagiChatBotInputArea.vue?vue&type=template&id=50f2600c&scoped=true"
import script from "./YagiChatBotInputArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./YagiChatBotInputArea.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./YagiChatBotInputArea.vue?vue&type=style&index=0&id=50f2600c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f2600c",
  null
  
)

export default component.exports